import { withRouter } from "react-router-dom";
import React, {Component} from 'react';
import SalesBasket from '../pages/SalesBasket';
import i18next from 'i18next';
import ErrorText from '../components/ErrorText';
import DataSource from "../util/DataSource";
import Spinner from "../components/Spinner";
import InfoText from "../components/InfoText";

class OrderDetails extends Component {

    constructor(props){
        super(props);
            this.state={
                orderheader: '',
                errorMessage: ''
            }

            this.errorNotResponseMessage = i18next.t("Η υπηρεσία δεν είναι διαθέσιμη αυτή τη στιγμή. Παρακαλώ επικοινωνήστε με την υποστήριξη πελατών");
    }

    render() {
        if (this.state.orderHeader) {
            return (
                <div>
                    <SalesBasket orderHeader={this.state.orderHeader} />
                    {this.renderDisclaimer()}
                </div>
            );
        }
        else if (this.state.errorMessage) {
            return (
                <ErrorText message={this.state.errorMessage} />
              );
        }
        else {
            return (<Spinner />);
        }
    }

    renderDisclaimer() {
        return (
            <div className="row mx-1 mt-3">
                    <InfoText message={this.getDisclaimerMessage()} />
                </div>
        );
    }

    getDisclaimerMessage() {
        return "Τα ανωτέρω στοιχεία έχουν πληροφοριακό και σε καμία περίπτωση αποδεικτικό ή δεσμευτικό χαρακτήρα, ενδέχεται δε να μεταβληθούν λόγω συνεχούς ροής καταχωρήσεων, ενημερώσεων, πληρωμής αξιογράφων, συμψηφιστικών εγγραφών κλπ. "
               + "Επίσημη απεικόνιση της οικονομικής κατάστασης της επιχείρησής σας εκδίδεται μόνον από το Τμήμα Πιστωτικού Ελέγχου της AEGEAN κατόπιν σχετικού αιτήματός σας, που σας αποστέλλεται ηλεκτρονικά ή με κούριερ.";
    }
        
    componentDidMount(){
        this.loadData(this.props.match.params.orderid);
    }

    loadData(_orderId) {

        DataSource.load("OrderHeader", {_orderId}, {associations: "Details, Details.LineItem, Details.Unit"})
        .then(data => {
            this.setState({ orderHeader : data });
        })
        .catch(error => {
            console.log(error);
            this.setState({ errorMessage : error.response? error.response.data.Message : this.errorNotResponseMessage, priceData : '' });
        });
    }


}
export default withRouter(OrderDetails);